import React from "react";
import PropTypes from "prop-types";
import styles from "./IntroduccioObservadorNoAdmin.module.css";

const IntroduccioObservadorNoAdmin = props => {
  const { nomObservador } = props;

  return (
    <div className={styles.introduccioObservador}>
      <strong>Observador</strong>
      <span>{nomObservador}</span>
    </div>
  );
};

IntroduccioObservadorNoAdmin.propTypes = {
  nomObservador: PropTypes.string.isRequired
};

export default IntroduccioObservadorNoAdmin;
